import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { HeroAsinWithIntent, ContentType } from "@/types/ab-tests";
import { getContentTypeLabel } from "@/utils/ab-test-utils";
import { ProductCardSmall } from "./ProductCardSmall";

interface CreateTestFullPageHeaderProps {
  heroAsin: HeroAsinWithIntent;
  step: 1 | 2;
  selectedFields: ContentType[];
  isEditing?: boolean;
  onBack: () => void;
  onEditFields: () => void;
}

export function CreateTestFullPageHeader({
  heroAsin,
  step,
  selectedFields,
  isEditing = false,
  onBack,
  onEditFields,
}: CreateTestFullPageHeaderProps) {
  return (
    <div className="border-b border-border bg-card px-9 py-5">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="icon" onClick={onBack} aria-label="Back">
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <div className="min-w-0 flex-1 space-y-1">
          <h1 className="text-3xl font-semibold text-foreground">{isEditing ? "Edit A/B Test" : "Create New A/B Test"}</h1>
          {step === 2 && (
            <div className="flex items-center gap-2">
              <p className="text-sm text-muted-foreground">
                Testing field:{" "}
                <span className="font-semibold text-foreground">
                  {selectedFields.map((f) => getContentTypeLabel(f)).join(", ")}
                </span>
              </p>
              <Button type="button" variant="link" size="sm" onClick={onEditFields} className="h-auto p-0 text-xs">
                Edit
              </Button>
            </div>
          )}
        </div>
        <div className="shrink-0 w-[420px]">
          <ProductCardSmall
            name={heroAsin.title}
            imageUrl={heroAsin.imageUrl}
            asin={heroAsin.asin}
          />
        </div>
      </div>
    </div>
  );
}
